// @flow
import React from "react";
import Sentry from "@nested/isomorphic-sentry";
import ServerError from "../pages/ServerError";

type Props = {
  error: Error,
};

class UniversalComponentError extends React.Component<Props> {
  componentDidMount() {
    const { error } = this.props;
    Sentry.captureException(error);
  }

  render() {
    return <ServerError />;
  }
}

export default UniversalComponentError;
